import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { Injectable } from '@angular/core';
import { Data } from '../model/data.model';
import { Guest } from '../model/guest.model';
import { Page } from '../model/page.model';
import { List } from '../model/list.model';
import { Cart, CartItem, CartTotal } from '../model/cart.model';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GuestService {

  constructor(private http:HttpClient) { }

  getGuestDetails(): Observable<Data<Guest>>{
    return this.http.get<Data<Guest>>(`${environment.apiURL}/User/AssignGuestID`).pipe(
      catchError(this.handleError)
    )
  }

  addProductGuestCart(data: CartItem, guestCartId: string | null): Observable<any> {
    return this.http.post<any>(`${environment.apiURL}/GuestCart/AddToCartByGuestUser/`+guestCartId, data ).pipe(
      catchError(this.handleError)
    )
  }

  getGuestCart(data: Page, guestCartId: string | null): Observable<Data<List<Cart>>> {
    return this.http.post<any>(`${environment.apiURL}/GuestCart/GuestCartList/`+guestCartId, data).pipe(
      catchError(this.handleError)
    )
  }

  deleteProductGuestCart(data: CartItem, guestCartId: string | null): Observable<any> {
    return this.http.delete<any>(`${environment.apiURL}/GuestCart/RemoveFromGuestCart/`+guestCartId, {body: data} ).pipe(
      catchError(this.handleError)
    )
  }

  getGuestCartCalculation(guestCartId: string | null): Observable<Data<CartTotal[]>> {
    return this.http.post<any>(`${environment.apiURL}/GuestCart/GetCartTotalGuestUser/`+guestCartId, null ).pipe(
      catchError(this.handleError)
    )
  }
  private handleError(err: HttpErrorResponse): Observable<never> {
    let errorMessage = '';
    if (err.error instanceof ErrorEvent) {
      errorMessage = `An error occurred: ${err.error.message}`;
    } 
    else {
      errorMessage = `Server returned code: ${err.status}, error message is: ${err.message}`;

    }
    return throwError(() => errorMessage);
  }

}


